import {gql} from "@apollo/client"

import {DomainUser} from "../../_generated/typed-document-nodes"

export const domainUserList = gql(`query domainUserList ($params: DomainUserQueryParams, $after: String) {
    domainUserList (params: $params, after: $after) {
        edges {
            creationDate
            creationUserId
            creationUserLabel
            lastModificationDate
            lastModificationUserId
            lastModificationUserLabel
            id
            civility
            firstName
            lastName
            email
            userId
            phone
            culture
            timeZone
            isEnabled
            domainId
            domainName
        }
        pageInfo {
            hasNextPage
            endCursor
        }
    }
}`)

export const addDomainUser = gql(`mutation addDomainUser ($item: DomainUserInput!) {
    addDomainUser (item: $item) {
        creationDate
        creationUserId
        creationUserLabel
        lastModificationDate
        lastModificationUserId
        lastModificationUserLabel
        id
        civility
        firstName
        lastName
        email
        userId
        phone
        culture
        timeZone
        isEnabled
        domainId
        domainName
    }
}`)

export const editDomainUser = gql(`mutation editDomainUser ($id: String!, $item: DomainUserInput!) {
    editDomainUser (id: $id, item: $item) {
        creationDate
        creationUserId
        creationUserLabel
        lastModificationDate
        lastModificationUserId
        lastModificationUserLabel
        id
        civility
        firstName
        lastName
        email
        userId
        phone
        culture
        timeZone
        isEnabled
        domainId
        domainName
    }
}`)

export const domainUserItems = gql(`query domainUserItems ($idList: [String!]!) {
    domainUserItems (idList: $idList) {
        creationDate
        creationUserId
        creationUserLabel
        lastModificationDate
        lastModificationUserId
        lastModificationUserLabel
        id
        civility
        firstName
        lastName
        email
        userId
        phone
        culture
        timeZone
        isEnabled
        domainId
        domainName
    }
}`)

export const domainUserRightList = gql`
    query domainUserRightList($domainUserId: String!, $params: RightValueQueryParams, $after: String) {
        domainUserRightList(domainUserId: $domainUserId, params: $params, after: $after) {
            edges {
                right
                value
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`

export const resendInviteDomainUser = gql(`mutation resendInviteDomainUser ($id: String!) {
    resendInviteDomainUser (id: $id)
}`)

export const editTenantUserRight =
    gql(`mutation editTenantUserRight ($tenantUserId: String!, $item: [TenantRightValueInput!]) {
    editTenantUserRight (tenantUserId: $tenantUserId, item: $item) {
        right
        value
    }
}`)

export const tenantUserRightList =
    gql(`query tenantUserRightList ($tenantUserId: String!, $params: RightValueQueryParams, $after: String) {
    tenantUserRightList (tenantUserId: $tenantUserId, params: $params, after: $after) {
        edges {
            right
            value
        }
        pageInfo {
            hasNextPage
            endCursor
        }
    }
}`)

export const initialDomainUser: DomainUser = {
    __typename: "DomainUser",
    civility: "",
    creationDate: null,
    creationUserId: null,
    creationUserLabel: null,
    culture: "",
    domainId: "",
    domainName: "",
    email: "",
    firstName: "",
    id: "",
    isEnabled: false,
    lastConnectionDate: null,
    lastModificationDate: null,
    lastModificationUserId: null,
    lastModificationUserLabel: null,
    lastName: "",
    phone: "",
    timeZone: "",
    userId: ""
}
